import React from "react";

const GeneralItemInfo = ({ formData, setFormData }) => {
  // Predefined options for hospital management
  const itemCategoryOptions = [
    { value: "Medical Equipment", label: "Medical Equipment" },
    { value: "Pharmaceuticals", label: "Pharmaceuticals" },
    { value: "Consumables", label: "Consumables" },
    { value: "Beds & Furniture", label: "Beds & Furniture" },
    { value: "Services", label: "Services" },
    { value: "Sanitation", label: "Sanitation" },
  ];

  const itemSubcategoryOptions = {
    "Medical Equipment": [
      { value: "Diagnostic Tools", label: "Diagnostic Tools" },
      { value: "Surgical Instruments", label: "Surgical Instruments" },
      { value: "Therapeutic Devices", label: "Therapeutic Devices" },
    ],
    Pharmaceuticals: [
      { value: "Tablets", label: "Tablets" },
      { value: "Capsules", label: "Capsules" },
      { value: "Syrups", label: "Syrups" },
      { value: "Injections", label: "Injections" },
    ],
    Consumables: [
      { value: "Protective Gear", label: "Protective Gear" },
      { value: "Sanitizers", label: "Sanitizers" },
      { value: "Disposable Items", label: "Disposable Items" },
    ],
    "Beds & Furniture": [
      { value: "Hospital Beds", label: "Hospital Beds" },
      { value: "Chairs", label: "Chairs" },
      { value: "Tables", label: "Tables" },
      { value: "Stretchers", label: "Stretchers" },
    ],
    Services: [
      { value: "Diagnostics", label: "Diagnostics" },
      { value: "Surgery", label: "Surgery" },
      { value: "Consultations", label: "Consultations" },
    ],
    Sanitation: [
      { value: "Cleaning Supplies", label: "Cleaning Supplies" },
      { value: "Disinfectants", label: "Disinfectants" },
    ],
  };

  const itemGroupOptions = {
    "Diagnostic Tools": [
      { value: "Thermometers", label: "Thermometers" },
      { value: "Blood Pressure Monitors", label: "Blood Pressure Monitors" },
      { value: "ECG Machines", label: "ECG Machines" },
    ],
    // ...other groups (trimmed for brevity)
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "item_category" && { item_subcategory: "", item_group: "" }),
      ...(name === "item_subcategory" && { item_group: "" }),
    }));
  };

  return (
    <form className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">General Item Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700">Item ID/Code</label>
          <input
            type="text"
            name="item_code"
            value={formData.item_code || ""}
            onChange={handleChange}
            placeholder="Enter item ID"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700">Item Name</label>
          <input
            type="text"
            name="items_name"
            value={formData.items_name || ""}
            onChange={handleChange}
            placeholder="Enter item name"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700">Item Category</label>
          <select
            name="item_category"
            value={formData.item_category || ""}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
            required
          >
            <option value="">Select Item Category</option>
            {itemCategoryOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-gray-700">Item Subcategory</label>
          <select
            name="item_subcategory"
            value={formData.item_subcategory || ""}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
            required
            disabled={!formData.item_category}
          >
            <option value="">Select Item Subcategory</option>
            {formData.item_category &&
              itemSubcategoryOptions[formData.item_category]?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </select>
        </div>
        <div>
          <label className="block text-gray-700">Item Group</label>
          <select
            name="item_group"
            value={formData.item_group || ""}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
            required
            disabled={!formData.item_subcategory}
          >
            <option value="">Select Item Group</option>
            {formData.item_subcategory &&
              itemGroupOptions[formData.item_subcategory]?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </select>
        </div>
        <div>
          <label className="block text-gray-700">Status</label>
          <select
            name="itemStatus"
            value={formData.itemStatus || ""}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
            <option value="Obsolete">Obsolete</option>
          </select>
        </div>
      </div>
    </form>
  );
};

export default GeneralItemInfo;
